<template>
  <div>
    <div v-if="allowActivity">
      <login-in-to-join-in :message="message" v-if="!loggedIn" :class="loginClass"></login-in-to-join-in>
      <add-display-name v-else-if="!completedLogin" :class="loginClass"></add-display-name>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LoginInToJoinIn from "./LoginInToJoinIn";
import AddDisplayName from "./AddDisplayName";

export default {
  name: "IfCanTakePart",
  // eslint-disable-next-line vue/no-unused-components
  components: {AddDisplayName, LoginInToJoinIn},
  props: {
    message: {
      type: String,
      required: false,
      default: "Log in to Join in"
    },
    loginClass: {
      type: String,
      required: false,
      default: ""
    },
  },
  computed: {
    ...mapGetters(["loggedIn", "completedLogin", "allowActivity"])
  }
};
</script>

<style scoped></style>
